import React, { useState } from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

export default function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    template: '',
    projectURL: '',
    purchaseDate: '',
    orderID: '',
    message: ''
  });

  const [errors, setErrors] = useState({
    name: '',
    email: '',
    subject: '',
    template: '',
    projectURL: '',
    purchaseDate: '',
    orderID: '',
    message: ''
  });

  const validateForm = () => {
    let isValid = true;
    const newErrors = {
      name: '',
      email: '',
      subject: '',
      template: '',
      projectURL: '',
      purchaseDate: '',
      orderID: '',
      message: ''
    };

    if (!formData.name) {
      newErrors.name = 'Name is required.';
      isValid = false;
    }
    if (!formData.email) {
      newErrors.email = 'Email is required.';
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address.';
      isValid = false;
    }
    if (!formData.subject) {
      newErrors.subject = 'Subject is required.';
      isValid = false;
    }
    if (!formData.template) {
      newErrors.template = 'Template name is required.';
      isValid = false;
    }
    if (!formData.projectURL) {
      newErrors.projectURL = 'Project URL is required.';
      isValid = false;
    }
    if (!formData.purchaseDate) {
      newErrors.purchaseDate = 'Purchase date is required.';
      isValid = false;
    }
    if (!formData.orderID) {
      newErrors.orderID = 'Order ID is required.';
      isValid = false;
    }
    if (!formData.message) {
      newErrors.message = 'Message is required.';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      console.log('Form submitted successfully:', formData);
    }
  };

  return (
    <div className="bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-navy-900">Support Request</h1>
          <p className="mt-4 text-xl text-navy-800">
            Please fill out the form below to get assistance with your template.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          <div>
            <div className="bg-gray-50 p-8 rounded-lg shadow-lg">
              <h2 className="text-2xl font-bold text-navy-900 mb-6">Contact Support</h2>
              <div className="space-y-6">
                <div className="flex items-center space-x-4">
                  <Mail className="w-6 h-6 text-navy-900" />
                  <div>
                    <p className="font-semibold">Email</p>
                    <p className="text-navy-800">support@templatehub.com</p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <Phone className="w-6 h-6 text-navy-900" />
                  <div>
                    <p className="font-semibold">Phone</p>
                    <p className="text-navy-800">+1 (555) 123-4567</p>
                  </div>
                </div>
                <div className="flex items-center space-x-4">
                  <MapPin className="w-6 h-6 text-navy-900" />
                  <div>
                    <p className="font-semibold">Address</p>
                    <p className="text-navy-800">123 Template Street, Web City, 12345</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <form onSubmit={handleSubmit} className="space-y-6">
              {Object.keys(formData).map((key) => (
                <div key={key}>
                  <label
                    htmlFor={key}
                    className="block text-sm font-medium text-navy-800"
                  >
                    {key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}
                  </label>
                  {key !== 'message' ? (
                    <input
                      type={key === 'email' ? 'email' : key === 'purchaseDate' ? 'date' : 'text'}
                      id={key}
                      value={formData[key]}
                      onChange={(e) =>
                        setFormData({ ...formData, [key]: e.target.value })
                      }
                      className="mt-1 block w-full rounded-md border-2 border-gray-300 shadow-sm focus:border-navy-500 focus:ring-navy-500 px-4 py-2"
                      required
                    />
                  ) : (
                    <textarea
                      id={key}
                      rows={4}
                      value={formData[key]}
                      onChange={(e) =>
                        setFormData({ ...formData, [key]: e.target.value })
                      }
                      className="mt-1 block w-full rounded-md border-2 border-gray-300 shadow-sm focus:border-navy-500 focus:ring-navy-500 px-4 py-2"
                      required
                    ></textarea>
                  )}
                  {errors[key] && (
                    <p className="mt-1 text-red-500 text-sm">{errors[key]}</p>
                  )}
                </div>
              ))}
              <button
                type="submit"
                className="w-full bg-navy-900 text-white py-3 px-6 rounded-md hover:bg-navy-800 transition-colors"
              >
                Submit Support Request
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
